import {
  CUSTOMER_RELATIONS_SET_EXTERNAL_RELATIONS,
  CUSTOMER_RELATIONS_EXTERNAL_PAGINATION,
  CUSTOMER_RELATIONS_SET_FETCHING_EXTERNAL_RELATIONS,

  CUSTOMER_RELATIONS_INTERNAL_PAGINATION,
  CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
  CUSTOMER_RELATIONS_SET_FETCHING_INTERNAL_RELATIONS,
  CUSTOMER_RELATIONS_SET_INTERNAL_RELATIONS,
  CUSTOMER_RELATIONS_SET_UPDATING_REGULAR_CUSTOMER,
  CUSTOMER_RELATIONS_SET_UPDATING_CORPORATE_CUSTOMER,
  CUSTOMER_RELATIONS_SET_IS_UPDATING_EXTERNAL_CUSTOMER
} from './actionTypes'
import { API_BASE_URL } from '../constants'
import { http, message } from '../utils'
import {forceLogoutUser} from "./authActions";

const fetchInternalRelations = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_FETCHING_INTERNAL_RELATIONS,
    payload: true,
  })

  return http
    .get(`${API_BASE_URL}/customer-relations/real?pageRowCount=${payload.pagination.pageSize}&pageIndex=${payload.page}&email=${payload.email}&name=${payload.name}`)
    .then(response => {
      const pagination = { ...payload.pagination };
      pagination.total = response.data.totalCount;

      dispatch({
        type: CUSTOMER_RELATIONS_INTERNAL_PAGINATION,
        payload: pagination,
      })

      dispatch({
        type: CUSTOMER_RELATIONS_SET_INTERNAL_RELATIONS,
        payload: response.data.customers,
      })

      dispatch({
        type: CUSTOMER_RELATIONS_SET_FETCHING_INTERNAL_RELATIONS,
        payload: false,
      })

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        dispatch({
          type: CUSTOMER_RELATIONS_SET_FETCHING_INTERNAL_RELATIONS,
          payload: false,
        })
      }
    })
}

const changeCustomerStatus = payload => dispatch => {
  return http
    .post(`${API_BASE_URL}/customer-relations/block/${payload.customerId}`, {isBlocked: payload.isBlocked})
    .then(() => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}

const changeCustomerLimit = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
    payload: true,
  })

  return http
    .put(`${API_BASE_URL}/customer-relations/limit/${payload.customerId}`, {limited: payload.limited, partLimit: payload.partLimit})
    .then(() => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
        payload: false,
      })
    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        dispatch({
          type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
          payload: false,
        })
        throw error
      }
    })
}


const changeCustomerAdjustment = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
    payload: true,
  })

  return http
    .put(`${API_BASE_URL}/customer-relations/adjustment/${payload.customerId}`, {adjustment: payload.adjustment})
    .then(() => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
        payload: false,
      })
    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        dispatch({
          type: CUSTOMER_RELATIONS_SET_IS_UPDATING_INTERNAL_CUSTOMER,
          payload: false,
        })
        throw error
      }
    })
}

const fetchExternalRelations = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_FETCHING_EXTERNAL_RELATIONS,
    payload: true,
  })

  return http
    .get(`${API_BASE_URL}/customer-relations/dummy?pageRowCount=${payload.pagination.pageSize}&pageIndex=${payload.page}&email=${payload.email}&name=${payload.name}`)
    .then(response => {
      const pagination = { ...payload.pagination };
      pagination.total = response.data.totalCount;

      dispatch({
        type: CUSTOMER_RELATIONS_EXTERNAL_PAGINATION,
        payload: pagination,
      })

      dispatch({
        type: CUSTOMER_RELATIONS_SET_EXTERNAL_RELATIONS,
        payload: response.data.customers,
      })

      dispatch({
        type: CUSTOMER_RELATIONS_SET_FETCHING_EXTERNAL_RELATIONS,
        payload: false,
      })

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        dispatch({
          type: CUSTOMER_RELATIONS_SET_FETCHING_EXTERNAL_RELATIONS,
          payload: false,
        })
      }
    })
}

const addNewRegularCustomer = payload => dispatch => {
  return http
    .post(`${API_BASE_URL}/customer-relations/dummy/regular-customer`, payload)
    .then(() => {})
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}

const addNewCorporateCustomer = payload => dispatch => {
  return http
    .post(`${API_BASE_URL}/customer-relations/dummy/corporate-customer`, payload)
    .then(() => {})
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}

const deleteExternalCustomer = payload => dispatch => {
  return http
    .delete(`${API_BASE_URL}/customer-relations/dummy/${payload.customerId}`)
    .then(() => {

    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}


const fetchCustomerDetails2 = payload => dispatch => {
  return http
    .get(`${API_BASE_URL}/customer-relations/dummy/${payload.id}`)
    .then(res => {
      return res.data.customers
    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}


const updateRegularCustomer = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_UPDATING_REGULAR_CUSTOMER,
    payload: true
  })

  return http
    .put(`${API_BASE_URL}/customer-relations/dummy/regular-customer/${payload.id}`, payload.data)
    .then(res => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_UPDATING_REGULAR_CUSTOMER,
        payload: false
      })
    })
    .catch(error => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_UPDATING_REGULAR_CUSTOMER,
        payload: false
      })
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}


const updateCorporateCustomer = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_UPDATING_CORPORATE_CUSTOMER,
    payload: true
  })
  return http
    .put(`${API_BASE_URL}/customer-relations/dummy/corporate-customer/${payload.id}`, payload.data)
    .then(res => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_UPDATING_CORPORATE_CUSTOMER,
        payload: false
      })
    })
    .catch(error => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_UPDATING_CORPORATE_CUSTOMER,
        payload: false
      })
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        throw error
      }
    })
}

const changeExternalCustomerAdjustment = payload => dispatch => {
  dispatch({
    type: CUSTOMER_RELATIONS_SET_IS_UPDATING_EXTERNAL_CUSTOMER,
    payload: true,
  })
  return http
    .put(`${API_BASE_URL}/customer-relations/dummy/adjustment/${payload.customerId}`, {adjustment: payload.adjustment})
    .then(() => {
      dispatch({
        type: CUSTOMER_RELATIONS_SET_IS_UPDATING_EXTERNAL_CUSTOMER,
        payload: false,
      })
    })
    .catch(error => {
      if(error?.response?.status === 401) {
        dispatch(forceLogoutUser())
      } else {
        message.show(message.type.error, http.getErrorMessage(error))
        dispatch({
          type: CUSTOMER_RELATIONS_SET_IS_UPDATING_EXTERNAL_CUSTOMER,
          payload: false,
        })
        throw error
      }
    })
}


export {
  fetchExternalRelations,
  changeCustomerStatus,
  changeCustomerLimit,
  changeCustomerAdjustment,
  fetchInternalRelations,
  addNewRegularCustomer,
  addNewCorporateCustomer,
  deleteExternalCustomer,
  fetchCustomerDetails2,
  updateRegularCustomer,
  updateCorporateCustomer,
  changeExternalCustomerAdjustment
}
